import React from 'react'
import { Header, HTMLText } from '@crossfit/ui'

import type { LiftingDailyClassPlanContent } from 'pages/Programming/types'
import Section from 'pages/Programming/components/Section'
import DailyClassPlanHeader from './Header'
import { useStrings } from 'components/Settings'
import ScoreTag from 'components/ScoreTag'
import style from './style.module.css'
import { trackEvent } from 'services/segment'

type Props = {
  classPlan: LiftingDailyClassPlanContent
}

function LiftingDailyClassPlan({ classPlan }: Props) {
  const strings = useStrings()
  const { type, name, accessoryWork, workouts = [] } = classPlan
  const [workout] = workouts

  const onCopy = (e) => {
    trackEvent({
      component: 'Lifting Daily Class plan',
      event: 'Lifting Daily Class plan Copied',
      location: 'Affiliate Toolkit',
      text: e.target.innerText,
    })
  }

  return (
    <main className={style.main} onCopy={onCopy}>
      <Section className={style.section}>
        <DailyClassPlanHeader name={name} type={type} />

        {workout && (
          <div className={style.content}>
            <div className={style.oneThirdContent}>
              <Header size='medium' as='h3' mb={4}>
                {workout.title}
              </Header>
              <HTMLText>{workout.description}</HTMLText>
              {workout.score && <ScoreTag>{workout.score}</ScoreTag>}
            </div>
            <div className={style.twoThirdContent}>
              <Header size='small' as='h4' mb={2}>
                {strings.notesText}
              </Header>
              <HTMLText>{workout.notes}</HTMLText>
            </div>
          </div>
        )}
      </Section>

      {accessoryWork && (
        <Section className={style.section}>
          <div className={style.workouts}>
            {accessoryWork.map((accessory, index) => (
              <div key={index}>
                <Header size='medium' as='h3' mb={4}>
                  {accessory.title}
                </Header>
                <HTMLText>{accessory.description}</HTMLText>
              </div>
            ))}
          </div>
        </Section>
      )}
    </main>
  )
}

export default LiftingDailyClassPlan
